















export default {
  name: 'RichText',
  props: {
    settings: {
      type: Object,
      required: true,
    },
    textContent: {
      type: String,
      default: () => '',
    },
  },
};
